<template lang="pug">
  DataTablePage(
    ref="table"
    mainColumn="name"
    longColumn="remark"
    :resource="resource"
    title="抄表详情"
    label="抄表详情"
    labelName="loginName"
    :operation="operation"
    :toolbar="toolbar"
    :operationWidth="220"
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :filterByAlways="filterByAlways"
    :columns="columns")
</template>

<script>
import DataTablePage from '@/containers/DataTablePage'
import fullColumns from '@/containers/meterReading/fullColumns'
import { toolbarBack } from '@/containers/DataTablePage/toolbar'

export default {
  name: 'Account',
  components: {
    DataTablePage
  },
  data () {
    return {
      toolbar: [toolbarBack],
      filterByAlways: [{
        name: 'scheduleId',
        type: 'eq',
        value: this.$route.params.id
      }],
      operation: [],
      resource: 'meterReading/readingData',
      tableInitList: ['areaCode', 'bookCode', 'pageCode', 'workDate', 'waterUserCode', 'waterUserName', 'waterUserAddress', 'readingUserId', 'readingStatusPreId', 'readingStatusId', 'runNumPre', 'runNumNow', 'waterUsePre', 'waterUseNow', 'feeNumPre', 'feeNumNow', 'waterUseNumChange', 'waveRangeRuleNum', 'waveRate', 'waveRangeTypeId'],
      tableFullList: ['areaCode', 'bookCode', 'pageCode', 'workDate', 'waterUserCode', 'waterUserName', 'waterUserAddress', 'readingUserId', 'readingStatusPreId', 'readingStatusId', 'runNumPre', 'runNumNow', 'waterUsePre', 'waterUseNow', 'feeNumPre', 'feeNumNow', 'waterUseNumChange', 'waveRangeRuleNum', 'waveRate', 'waveRangeTypeId'],
      filterInitList: [],
      filterFullList: [],
      columns: {
        ...fullColumns
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// index.vue?c616588c